<template>
  <el-dialog :visible.sync="changeRoleDialogVisible"  title="更改用户组" @close="feedBack" v-if="changeRoleDialogVisible">
    <el-form label-width="100px">
      <el-form-item label="原用户组">
        <el-tag>{{getRole(originalRole)}}</el-tag>
      </el-form-item>
      <el-form-item label="新用户组" >
        <el-select>
          <el-option :value="0">超级管理员</el-option>
          <el-option :value="1">普通管理员</el-option>
          <el-option :value="2">维修人员</el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="feedBack">取 消</el-button>
      <el-button type="primary" @click="feedBack">确定修改</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ChangeRole',
    props: ['changeRoleDialogVisible','originalRole'],
    data() {
      return {
        // 变更管理区域
        UpdateAreaManager:{
          "version": 1,
          "method": "user.UpdateAreaManager",
          "params": {
            "userId": "",
            "newAreaId": "",
          },
          "token": "",
          "id": 0
        }
      }
    },
    methods: {
      getRole(role){
        if(role === 0){
          return "超级管理员";
        }else if(role === 1){
          return "普通管理员";
        }else if(role === 2){
          return "维修人员";
        }else {
          return "角色错误";
        }
      },
      feedBack(){
        this.changeRoleDialogVisible = false;
        this.$emit('feedBack',this.changeRoleDialogVisible);
      }
    }
  }
</script>

<style scoped>

</style>
